import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { useRootSelector } from "@/infrastructure/hooks";
import { FireSel } from "@/features/firestore";
import { useWatchListContext } from "@/modules/Watchlist/hooks";
import { useUserPreference } from "@/features/applications/hook";

export default () => {
  const { country, setCountry } = useWatchListContext();
  const countryExchange = useRootSelector(FireSel.countryExchange);
  const { userPreference, updateUserPreference } = useUserPreference();

  return (
    <Autocomplete
      multiple
      options={countryExchange}
      getOptionLabel={option => option.country}
      value={countryExchange.filter(e => country.includes(e.country))}
      filterSelectedOptions
      onChange={(_e, v) => updateSelectedCountry(v.map(e => e.country))}
      renderInput={params => <TextField {...params} variant="standard" label="Select multiple countries" />}
    />
  );


  function updateSelectedCountry(countries: string[]) {
    setCountry(countries)
    updateUserPreference({ ...userPreference, selectedCountry: countries });
  }

};
